import React from 'react'

const RightArrowIcon = (props = {}) => {
  const {
    className = '',
    width = '40',
    height = '40',
    fill = 'none',
    viewBox = '0 0 40 40',
    dataTestId = 'left-arrow-icon',
    ariaLabel = 'Left Icon',
    fillColor = '#5F5F5F', // Set default fill color to white
  } = props || {}
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      className={className}
      viewBox={viewBox}
      data-testid={dataTestId}
      aria-label={ariaLabel}>
      <rect width="40" height="40" rx="20" fill="#F5F5F5" />
      <path
        d="M25 20C25 20.5522 24.6077 20.9998 24.124 21L13.876 21C13.3921 21 13 20.5523 13 20C13 19.4477 13.3921 19 13.876 19L24.124 19C24.6077 19.0002 25 19.4478 25 20Z"
        fill={fillColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6187 19.3813C26.9604 19.723 26.9604 20.277 26.6187 20.6187L20.4937 26.7437C20.152 27.0854 19.598 27.0854 19.2563 26.7437C18.9146 26.402 18.9146 25.848 19.2563 25.5063L24.7626 20L19.2563 14.4937C18.9146 14.152 18.9146 13.598 19.2563 13.2563C19.598 12.9146 20.152 12.9146 20.4937 13.2563L26.6187 19.3813Z"
        fill={fillColor}
      />
    </svg>
  )
}

export default RightArrowIcon
export { RightArrowIcon }
